var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"align-center":"","column":""}},[_c('p',{staticClass:"Section-Title"},[_vm._v("Pertanyaan Seputar Pendanaan")]),_c('div',{staticStyle:{"width":"320px"}},[_c('v-divider'),_vm._l((_vm.questions),function(data){return _c('pertanyaan-content-mobile',{key:data,attrs:{"data":data}})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }